module.exports = __webpack_public_path__ + "images/emoji/sparkling_heart.d4ba2ce9df3154e1f0b4.png";